import {
  CUSTOM_ERROR_HANDLERS_CREATOR,
  CustomErrorHandlersCreator,
  REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE
} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';
import {RouterActions, SnackBarActions} from '@store/aviary/aviary.adapter';
import {RegistrationActions} from './registration.actions';

export function contextWithErrorHandlerForRequestVerificationEmail(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // email already exists on patron other than current authorized patron
          errorCodes: 'GENERAL_DUPLICATE_EMAIL',
          actions: SnackBarActions.showError('This email is already in use, please choose another.')
        },
        {
          // email is blank or already verified
          errorCodes: 'GENERAL_INVALID_VALUE',
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForVerifyEmail(doNavigates: boolean): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          errorCodes: 'PATRON_VERIFICATION_EXPIRED',
          actions: [
            SnackBarActions.showError('Verification code has expired.'),
            RegistrationActions.setVerificationExpired(true),
            ...doNavigates ? [RouterActions.navigateTo('INDEX')] : []
          ]
        },
        {
          errorCodes: 'PATRON_VERIFICATION_CODE_INCORRECT',
          actions: [
            SnackBarActions.showError('Verification code is incorrect.'),
            ...doNavigates ? [RouterActions.navigateTo('INDEX')] : []
          ]
        },
        {
          // ENTITY_ID_NOT_FOUND: failed to find the verification object from the uuid,
          // PATRON_VERIFICATION_INVALID_TYPE: verification is not an email verification, may be a phone call or sms verification
          // PATRON_VERIFICATION_INVALID_STATUS: verification status is invalid, possibly from finished registration or from failing too many attempts
          errorCodes: ['ENTITY_ID_NOT_FOUND', 'PATRON_VERIFICATION_INVALID_TYPE', 'PATRON_VERIFICATION_INVALID_STATUS'],
          actions: [
            SnackBarActions.showError('Failed to verify the email. Please refresh, resend the code, and try again. If the problem persists, contact your library staff.'),
            ...doNavigates ? [RouterActions.navigateTo('INDEX')] : []
          ]
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
